"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const google_map_react_1 = __importDefault(require("google-map-react"));
const React = __importStar(require("react"));
const pin_svg_1 = __importDefault(require("./pin.svg"));
const MapMarker = styled_1.default.div `
	position: absolute;
	top: calc(100% - 40px);
	left: calc(50% - 15px);
	z-index: 1;

	img {
		height: 40px;
		width: 30px;
	}
`;
const MAP_KEY = process.env.GOOGLE_MAPS_API_KEY || 'GOOGLE_MAPS_API_KEY_NOT_SET';
const Marker = ({}) => React.createElement(MapMarker, null,
    React.createElement("img", { className: "map-marker-image", src: pin_svg_1.default }));
const round = (num) => {
    return parseFloat(parseFloat((num || 0)).toString().substring(0, 8));
};
const interactionDisabledProps = () => ({
    draggable: false,
    options: {
        disableDefaultUI: true
    }
});
const Map = ({ lat, lng, width, height, zoom, readonly, interactive, onChange }) => {
    const inputLatLng = [round(lat), round(lng)];
    const [latLng, setLatLng] = React.useState(inputLatLng);
    React.useEffect(() => {
        // respond to external updates to props
        change(inputLatLng[0], inputLatLng[1]);
    }, [...inputLatLng]);
    const change = (nextLat, nextLng) => {
        const next = [round(nextLat), round(nextLng)];
        if ((latLng[0] !== next[0] || latLng[1] !== next[1])) {
            setLatLng(next);
            if (onChange)
                onChange(next[0], next[1]);
        }
    };
    return React.createElement("div", { style: { width: width || '100%', height: height || '100%', position: 'relative' } },
        React.createElement(google_map_react_1.default, Object.assign({ bootstrapURLKeys: { key: MAP_KEY }, center: { lat: latLng[0] || 0, lng: latLng[1] || 0 }, zoom: zoom || 16, resetBoundsOnResize: true }, (interactive === false ? interactionDisabledProps() : null), !readonly ? { onClick: (a) => change(a.lat, a.lng) } : null),
            React.createElement(Marker, { lat: latLng[0], lng: latLng[1] })));
};
exports.Map = Map;
//# sourceMappingURL=Map.js.map